// List all verticals here

const verticalList = [
    {
        name: "Web",
        path: "/web",
        group: -1,
        icon: "/assets/images/common/icon_search.svg",
        component: () =>
            import(
                /* webpackChunkName: "Web" */ "./pages/search/views/web/Web.vue"
            ),
    },
    {
        name: "Recipes",
        path: "/recipes",
        group: 9,
        icon: "/assets/images/common/icon_recipe.svg",
        component: () =>
            import(
                /* webpackChunkName: "Recipes" */ "./pages/search/views/recipes/Recipes.vue"
            ),
    },
    {
        name: "TV/Movies",
        path: "/tvguide",
        group: -2, //no search suggestions
        icon: "/assets/images/common/icon_tv.svg",
        component: () =>
            import(
                /* webpackChunkName: "TvGuide" */ "./pages/search/views/tvguide/TVGuide.vue"
            ),
    },
    {
        name: "Templates",
        path: "/templates",
        group: 4, //no search suggestions
        icon: "/assets/images/common/icon_template.svg",
        component: () =>
            import(
                /* webpackChunkName: "Manuals" */ "./pages/search/views/templates/Templates.vue"
            ),
    },
    {
        name: "Manuals",
        path: "/manuals",
        group: 12, //no search suggestions
        icon: "/assets/images/common/icon_manual.svg",
        component: () =>
            import(
                /* webpackChunkName: "Manuals" */ "./pages/search/views/manuals/Manuals.vue"
            ),
    },
];

const reorderedVerticalList = [
    {
        name: "Recipes",
        path: "/recipes",
        group: 9,
        icon: "/assets/images/common/icon_recipe.svg",
        component: () =>
            import(
                /* webpackChunkName: "Recipes" */ "./pages/search/views/recipes/Recipes.vue"
            ),
    },

    {
        name: "Templates",
        path: "/templates",
        group: 4, //no search suggestions
        icon: "/assets/images/common/icon_template.svg",
        component: () =>
            import(
                /* webpackChunkName: "Manuals" */ "./pages/search/views/templates/Templates.vue"
            ),
    },
    {
        name: "Manuals",
        path: "/manuals",
        group: 12, //no search suggestions
        icon: "/assets/images/common/icon_manual.svg",
        component: () =>
            import(
                /* webpackChunkName: "Manuals" */ "./pages/search/views/manuals/Manuals.vue"
            ),
    },
    {
        name: "TV/Movies",
        path: "/tvguide",
        group: -2, //no search suggestions
        icon: "/assets/images/common/icon_tv.svg",
        component: () =>
            import(
                /* webpackChunkName: "TvGuide" */ "./pages/search/views/tvguide/TVGuide.vue"
            ),
    },
];

const mobileVerticalList = [
    {
        name: "Web",
        path: "/web",
        group: -1,
        icon: "/assets/images/common/icon_search.png",
        component: () =>
            import(
                /* webpackChunkName: "MobileWeb" */ "./pages/search/mobileViews/web/Web.vue"
            ),
    },
    {
        name: "Recipes",
        path: "/recipes",
        group: 9,
        icon: "/assets/images/common/icon_recipes.png",
        component: () =>
            import(
                /* webpackChunkName: "MobileRecipes" */ "./pages/search/mobileViews/recipes/Recipes.vue"
            ),
    },
];

function hasMobileView(viewName) {
    let hasMobileView = mobileVerticalList.find(el => el.name == viewName);
    if (hasMobileView && hasMobileView !== undefined) return true;
    else return false;
}

const defaultVertical = verticalList.find(el => (el.name = "Web"));

const homepageIncludeParams = ["type", "guid"];

const footerList = [
    { name: "Terms of Service", path: "/terms-of-service.html" },
    { name: "Privacy", path: "/privacy-policy.html" },
    { name: "Contact Us", path: "/contact-us.html" },
    { name: "Unsubscribe", path: "/unsubscribe.html" },
];

export {
    verticalList,
    mobileVerticalList,
    reorderedVerticalList,
    hasMobileView,
    defaultVertical,
    footerList,
    homepageIncludeParams,
};
